import * as DKFDS from 'dkfds';
import $ from 'jquery';
import { fdsReset, fdsShowFieldError } from '../modals';

function checkPartialVerify(noCases, hasVerify, hasNotVerify) {
    return noCases > 1 && hasVerify && hasNotVerify
        ? 'Nogle af annulleringerne skal godkendes af vejmyndighederne.'
        : '';
}

function checkMultipleVerify(noCases, hasVerify, hasNotVerify) {
    return noCases > 1 && hasVerify && !hasNotVerify
        ? 'Annulleringerne skal godkendes af vejmyndighederne.'
        : checkPartialVerify(noCases, hasVerify, hasNotVerify);
}

function checkVerify(noCases, hasVerify, hasNotVerify) {
    return noCases === 1 && hasVerify
        ? 'Annulleringen skal godkendes af vejmyndigheden.'
        : checkMultipleVerify(noCases, hasVerify, hasNotVerify);
}

function onShowModal($modal) {
    const $checked = $(':checked[name=selectedCases]');
    const noCases = $checked.length;
    const $modalText = $('#cancelCasesModalText');
    const ids = $checked.map(function () { return this.value; }).get();
    const verifies = ids.map(id => $(`#verifyCancel[${id}]`).val());
    const hasVerify = verifies.includes('true');
    const hasNotVerify = verifies.includes('false');
    const verifyText = checkVerify(noCases, hasVerify, hasNotVerify);

    const casesText = noCases === 1 ? ' sag' : ' sager';
    if (nameSpace === '/gt') {
        $modalText.html(`Du er i gang med at annullere ${ noCases + casesText }. ${verifyText}<br />Er der udført arbejde på veje, skal arbejdet færdigmeldes.`);
    } else {
        $modalText.html(`Du er i gang med at annullere ${ noCases + casesText }. ${verifyText}`);
    }

    $('#cancelCasesModalFieldset').show().find('textarea').val('');
}

function onClick() {
    const noCases = $(':checked[name=selectedCases]').length;
    if (noCases === 0) {
        new DKFDS.Toast(document.getElementById('cancelCasesError')).show();
    }
    else {
        new DKFDS.Modal(document.getElementById('cancelCasesModal')).show();
    }
}

$(() => {
    const $modal = $('#cancelCasesModal');

    $modal.get(0).addEventListener('fds.modal.shown', () => onShowModal($modal));
    $modal.get(0).addEventListener('fds.modal.hidden', () => fdsReset($modal));

    $('#cancelCasesButton').on('click', onClick);

    $('#cancelCasesModalOK').on('click', () => {
        const $textarea = $('textarea[name="cancelComment"]');
        if ($textarea.val().trim() === '') {
            fdsShowFieldError($textarea, 'Skal udfyldes');
            return;
        }

        $('#cancelCasesLoading').show();
        $('form')
            .attr('enctype', 'application/x-www-form-urlencoded')
            .append('<input type="hidden" name="doCancel" value="true"/>')
            .submit();
    });
});
